export const initRequestES = (itemRef: string, widgetType: string) => {
  return {
    mode: "item_edit",
    reference: itemRef,
    config: {
      dependencies: {
        question_editor_api: {
          init_options: {
            base_question_type: {
              hidden: ["shuffle_options"],
            },
            widget_type: "response",
            ui: {
              layout: {
                global_template: "edit",
              },
              change_button: false,
              distractor_rationale_button: {
                enabled: true,
                options: ["perQuestion", "perResponse"],
              },
            },
          },
          preload: true,
        },
      },
      widget_templates: {
        back: false,
        save: false,
        widget_types: {
          default: widgetType,
          show: true,
        },
      },
      container: {
        height: "auto",
        fixed_footer_height: 0,
      },
      item_edit: {
        tags_on_create: [
          {
            type: widgetType == "questions" ? "Questions" : "Features",
            name: widgetType == "questions" ? "Questions" : "Features",
          },
        ],
        item: {
          back: false,
          save: false,
          tag: {
            edit: true,
            show: true,
          },
        },
      },
    },
    user: {
      id: "demoTest",
      firstname: "",
      lastname: "",
      email: "",
    },
  };
};
